import { useQuery } from 'react-query'
import { useOffer } from './offer'
import { api } from 'src/services/api'

export const useMiddlewareOffer = () => {
	const { currentOffer } = useOffer()

	return useQuery(
		['middleware-offer', currentOffer],
		() =>
			api.get(`/publico/campanhas/${currentOffer}`).then(res => res.data[0]),
		{
			enabled: !!currentOffer
		}
	)
}
